import axios from 'axios';

export const dispatchRequest = async <T>(request: IRequest<T>) => {
    const url = request.url;
    const body = request.body;

    return body ? (await axios.post(url, body)).data : (await axios.get(url)).data;
}
